/**
 * Punto de entrada Standalone para TIA GPC Widget
 *
 * Este bundle incluye React y todas las dependencias necesarias.
 * Puede ser usado directamente en HTML, Angular, ASP.NET, PHP, etc.
 *
 * Uso:
 * <script src="tia-gpc-widget.standalone.js"></script>
 * <tia-gpc-widget token="tu-token"></tia-gpc-widget>
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { TiaGPCWebComponent } from './components/WebComponentWrapper';
import './styles/index.css';
import './styles/widget.css';
import './styles/responsive.css';
import { WIDGET_POSITIONS, THEMES, LANGUAGES } from './utils/constants';

/**
 * API Global para inicialización programática
 */
window.TiaGPC = {
  version: '1.0.0',

  POSITIONS: WIDGET_POSITIONS,
  THEMES: THEMES,
  LANGUAGES: LANGUAGES,

  create(config) {
    if (!config || !config.token) {
      throw new Error('TiaGPC.create(): El parámetro "token" es requerido');
    }

    const widget = document.createElement('tia-gpc-widget');

    widget.setAttribute('token', config.token);

    if (config.theme) widget.setAttribute('theme', config.theme);
    if (config.position) widget.setAttribute('position', config.position);
    if (config.language) widget.setAttribute('language', config.language);
    if (config.primaryColor) widget.setAttribute('primary-color', config.primaryColor);
    if (config.width) widget.setAttribute('width', config.width);
    if (config.height) widget.setAttribute('height', config.height);
    if (config.apiUrl) widget.setAttribute('api-url', config.apiUrl);
    if (config.turnstileSiteKey) widget.setAttribute('turnstile-site-key', config.turnstileSiteKey);
    if (config.autoOpen !== undefined) widget.setAttribute('auto-open', String(config.autoOpen));
    if (config.showBranding !== undefined) widget.setAttribute('show-branding', String(config.showBranding));
    if (config.mobileFullscreen !== undefined) widget.setAttribute('mobile-fullscreen', String(config.mobileFullscreen));

    if (config.onReady) {
      widget.addEventListener('ready', config.onReady);
    }
    if (config.onError) {
      widget.addEventListener('error', (e) => config.onError(e.detail));
    }
    if (config.onClose) {
      widget.addEventListener('close', config.onClose);
    }

    const container = config.container || document.body;
    container.appendChild(widget);

    return widget;
  },

  /**
   * Información sobre el widget
   */
  info() {
    console.log(`
╔═══════════════════════════════════════════════════════════╗
║              TIA GPC Widget - Standalone                  ║
╟───────────────────────────────────────────────────────────╢
║  Versión: ${this.version}                                      ║
║  React incluido: Sí                                       ║
║  Uso: <tia-gpc-widget token="..."></tia-gpc-widget>       ║
║                                                           ║
║  Documentación: README.md                                 ║
╚═══════════════════════════════════════════════════════════╝
    `);
    return {
      version: this.version,
      positions: this.POSITIONS,
      themes: this.THEMES,
      languages: this.LANGUAGES
    };
  }
};

if (process.env.NODE_ENV !== 'production') {
  console.log('✅ TIA GPC Widget (Standalone) cargado correctamente');
  console.log('💡 Usa TiaGPC.info() para ver información del widget');
}

export { TiaGPCWebComponent };
export default window.TiaGPC;
